import { find } from 'lodash';
const BASEURL = 'https://api.stibee.com/v1';

const newsletter = {
  init() {
    $(document).ready(function() {
      $('.form-newsletter').submit(function(event) {
        event.preventDefault();

        const data = $(this).serializeArray();
        const api = find(data, ['name', 'api']).value;
        const list = find(data, ['name', 'list']).value;
        const email = find(data, ['name', 'list']).value;

        $.ajax({
          url: BASEURL + '/lists/' + list + '/subscribers',
          contentType: 'application/json',
          dataType: 'json',
          headers: {
            AccessToken: api,
          },
          data: {
            subscribers: [{ email }],
          },
        });

        // console.log('serial', data);
      });
      console.log('init');
    });
  },
};

export default newsletter;



// WEBPACK FOOTER //
// ./scripts/newsletter.js